import { useContext, useEffect, type FC } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { canViewSupersetDashboards } from "@thalamos/aspire-common";

import {
  DataGlossaryPageInner,
  type DataGlossaryPageInnerProps,
} from "./DataGlossaryPageInner.js";
import { apiHooks } from "~/api.js";
import { LoggedInUserContext } from "~/Contexts.js";
import { routeFns } from "~/routePaths.js";

export type { DataGlossaryPageInnerProps };
export { DataGlossaryPageInner };

export const DataGlossaryPage: FC = () => {
  const userContext = useContext(LoggedInUserContext);
  const user = userContext?.user;
  const navigate = useNavigate();
  const { dashboardId } = useParams();

  const [{ data: glossaryData, loading }] = dashboardId
    ? apiHooks.supersetDashboards.getDataGlossary(dashboardId)
    : [{ data: null, loading: false }];

  useEffect(() => {
    if (!canViewSupersetDashboards(user)) {
      navigate(routeFns.home());
    }
  }, [user, navigate]);

  return (
    <DataGlossaryPageInner
      dataGlossaryMarkdown={glossaryData?.dataGlossaryMarkdown ?? null}
      loading={loading}
      onBackClick={() => {
        navigate(routeFns.dashboard());
      }}
    />
  );
};
